import { IntlFormatters } from "react-intl";
import { TApp } from "../types";

export const availableLanguages = [
    "hu",
    "en-gb",
    "en-us",
    "it",
    "es",
    "lt",
    "ro",
    "ja",
    "et",
    "nl",
    "pl",
    "zh",
    // "zh-hant",
    "hr",
    "el",
    "ca",
    "tr",
    "de",
];

export const removedLanguages = ["zh", "zh-hant", "pt", "ga"];
export const availableMainLanguages = [
    "hu",
    "en",
    "it",
    "es",
    "lt",
    "ja",
    "et",
    "pl",
    // "zh",
    "nl",
    "ro",
    "hr",
    "el",
    "ca",
    "tr",
    "de",
];

export const availableLanguagesForTranslation = [
    "de",
    // "pt",
    "pl",
    "ro",
    "es",
    "el",
    "tr",
    "nl",
    "ca",
    "lt",
    "et",
    "hr",
    "it",
    "en-gb",
    "en-us",
    "ja",
    "zh",
    // "zh-hant",
];

export const wantedLanguages = ["el", "ja", "pl", "zh", "zh-hant", "pt"];

export const wantedLanguagesForApproval = ["de", "sp"];

export const completedLanguages = ["hu", "en-gb", "en-us", "it", "hr", "lt", "et", "ro", "ca", "el", "nl", "tr", "de", "es"];

export const translationLevelStatusOptions = {
    PROGRESS: 1,
    UPDATE: 2,
    TEST: 3,
    DONE: 4,
};

export const newsletterLocales = ["en", "hu", "lt", "it", "ro"];

export const translationLevelStatusLabels = ["Closed", "In progress", "In progress (update)", "Testing", "Done"];

export const getLocale = (locale: string) => {
    if (locale === "en-us" || locale === "en-gb") {
        return "en";
    }
    if (locale === "zh-hant") {
        return "zh";
    }
    return locale;
};

export const languages = (fm: IntlFormatters["formatMessage"], isChoir?: boolean) => {
    return availableLanguages.filter(al => isChoir ? (al === 'hu' || al === 'en-us') : true).map(language => ({
        label: fm({ id: `language.${language}` }),
        value: language,
    }));
};

export const mainLanguages = (fm: IntlFormatters["formatMessage"]) => {
    return availableMainLanguages.map(language => ({
        label: fm({ id: `language.${language}` }),
        value: language,
    }));
};

const availableSeoImages = ["hu", "en", "et", "lt", "pl", "ga", "it", "es", "hr", "ca", "el", "ro", "nl"];
const availableSeoImagesMemory = ["hu", "en", "it", "et", "hr", "lt", "ca", "nl"];

export const getAvailableLogoLocale = (locale: string, app?: TApp | undefined) => {
    if (app === 'memory') {
        if (availableSeoImagesMemory.includes(locale)) {
            return locale;
        }
        return "en";
    }
    if (app === 'choir') {
        return "hu";
    }
    if (availableSeoImages.includes(locale)) {
        return locale;
    }
    return "en";
};

export const getLangFlag = (locale: string) => {
    if (locale === "en-gb") {
        return "gb";
    }

    if (locale === "en-us") {
        return "us";
    }

    if (locale === "ca") {
        return "catalan";
    }

    if (locale === "zh-hant") {
        return "tw";
    }
    return locale;
};
